import { application } from "./application"
import HelloController from "./hello_controller"
import NavbarController from "./navbar_controller"
import AutoresizeController from "./autoresize_controller"
import CommentSubmitController from "./comment_submit_controller"

application.register("hello", HelloController)
application.register("navbar", NavbarController)
application.register("autoresize", AutoresizeController)
application.register("comment-submit", CommentSubmitController)
